export default __webpack_public_path__ + "static/media/sensotrend_dashboard_sharing_link.50824cc7.png";